var _path, _path2, _path3, _path4, _path5, _path6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharingRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12137_106367",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12137_106367)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12137_106367",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12137_106367)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00394 13.2495H6.83391C6.75864 13.2483 6.68448 13.2334 6.61615 13.2056C6.54783 13.1779 6.48685 13.138 6.43709 13.0884C6.32613 12.9786 6.26412 12.8373 6.26249 12.6905V4.46674C6.26287 4.31978 6.32504 4.17811 6.43709 4.06887C6.48581 4.01749 6.54633 3.97569 6.61471 3.94621C6.68308 3.91673 6.75777 3.90023 6.83391 3.89778H8.01075C8.08674 3.89742 8.16183 3.88328 8.23129 3.85624C8.30075 3.82919 8.36308 3.78983 8.41436 3.74063C8.51741 3.64182 8.5741 3.51251 8.57309 3.37858C8.57322 3.2448 8.51665 3.11576 8.41436 3.01653C8.36308 2.96733 8.30075 2.92796 8.23129 2.90092C8.16183 2.87387 8.08674 2.85974 8.01075 2.85938H6.83391C6.60677 2.86244 6.3828 2.90659 6.17601 2.98909C5.96922 3.07158 5.78406 3.19063 5.63213 3.33879C5.31425 3.64789 5.14026 4.05044 5.14461 4.46674V12.6826C5.14039 13.0983 5.3144 13.5001 5.63213 13.8085C5.78406 13.9567 5.96922 14.0757 6.17601 14.1582C6.3828 14.2407 6.60677 14.2849 6.83391 14.2879H8.01075C8.08674 14.2876 8.16183 14.2734 8.23129 14.2464C8.30075 14.2193 8.36308 14.18 8.41436 14.1308C8.51634 14.0314 8.57278 13.9024 8.57278 13.7687C8.57278 13.635 8.51634 13.5061 8.41436 13.4067C8.3623 13.3567 8.29887 13.3169 8.22817 13.2899C8.15747 13.2628 8.08108 13.2491 8.00394 13.2495Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3852 14.704L10.3732 14.7038M10.3732 14.7038C10.3033 14.7013 10.2345 14.6849 10.171 14.6554C10.1074 14.6258 10.0503 14.5838 10.0031 14.5316L9.99925 14.5272C9.90475 14.4187 9.85215 14.2792 9.85195 14.1347V2.99522C9.84985 2.85632 9.89735 2.72166 9.98535 2.61491C10.0645 2.51552 10.1774 2.44918 10.3019 2.42766L10.33 2.42278H10.3587H10.4362H10.4756L10.5139 2.43198L14.9697 3.50106L14.975 3.50237C15.0942 3.53303 15.1993 3.60477 15.2711 3.70575C15.3438 3.80649 15.3829 3.92829 15.3823 4.05297V8.5V13.0395C15.3823 13.3111 15.1999 13.5488 14.9375 13.6191L13 14.1376L10.3732 14.7038ZM15.0056 3.14422C15.2013 3.19266 15.3724 3.30782 15.4892 3.46828C15.6146 3.64171 15.6808 3.84958 15.6787 4.0619L15.6786 4.06523V13.0878V13.0893C15.6796 13.3002 15.6135 13.5064 15.4891 13.6788C15.3722 13.8394 15.2007 13.9545 15.0048 14.0025L10.554 15.0775C10.5202 15.0818 10.4862 15.084 10.4521 15.0843L10.4397 15.0844L10.4274 15.0854C10.4061 15.0871 10.3847 15.0871 10.3634 15.0854L10.3531 15.0845L10.3429 15.0843C10.2298 15.0821 10.1185 15.0566 10.0161 15.0097C9.91385 14.9628 9.82275 14.8955 9.74845 14.8124L9.74625 14.8099C9.57785 14.625 9.48615 14.3851 9.48832 14.1376L9.48833 14.1347V2.99212L9.48832 2.99011C9.48683 2.74306 9.57845 2.5037 9.74635 2.31885C9.82265 2.23521 9.91565 2.16773 10.0198 2.1208C10.1241 2.07383 10.2373 2.04852 10.3521 2.04655L10.3694 2.04625L10.3866 2.04416C10.4426 2.03736 10.4992 2.03736 10.5551 2.04416L10.5749 2.04658L15.0056 3.14422Z",
    stroke: "currentColor",
    strokeWidth: 0.666667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4362 9.16138C11.7558 9.16138 12.0149 8.90227 12.0149 8.58264C12.0149 8.26302 11.7558 8.00391 11.4362 8.00391C11.1165 8.00391 10.8574 8.26302 10.8574 8.58264C10.8574 8.90227 11.1165 9.16138 11.4362 9.16138Z",
    fill: "CurrentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12137_106367",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 6,
    width: 7,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33443 6.67188H-0.570312V12.5766H5.33443V6.67188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12137_106367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.660156 9.625H4.10459",
    stroke: "currentColor",
    strokeWidth: 0.895553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 7.90234L4.10503 9.62456L2.38281 11.3468",
    stroke: "currentColor",
    strokeWidth: 0.895553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingRoom);
export default __webpack_public_path__ + "static/media/sharing_room.ef3b2e002323073a7cf87ed01941e23e.svg";
export { ForwardRef as ReactComponent };